import { Injectable, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CommonTemplatesService {

	nguidCellTemplate: TemplateRef<any>;
	globalIdCellTempl: TemplateRef<any>;
	qaErrorLevelCellTempl: TemplateRef<any>;
	constructor() { }
}
